// Helpers for seller-supplied links (shop website/social, tracking links).
// Only https links are ever opened: a plain http link can be intercepted or
// swapped on the way, and these links come from sellers, not from Ngwaahia.

const SCHEME = /^[a-z][a-z0-9+.-]*:/i;
const BARE_DOMAIN = /^(?:www\.)?[a-z0-9-]+(?:\.[a-z0-9-]+)+(?:[/?#].*)?$/i;
const HOST = /^[a-z0-9-]+(?:\.[a-z0-9-]+)+$/i;

// The host of an https URL, lowercased, without "www.". Null for anything
// else, including URLs with a user@ part ("https://ngwaahia.com@evil.com"
// opens evil.com), since those exist to disguise where the link goes.
export const getUrlDomain = (url) => {
  const match = /^https:\/\/([^/?#]*)/i.exec(url || "");
  if (!match) return null;
  const authority = match[1];
  if (authority.includes("@")) return null;
  const host = authority.replace(/:\d+$/, "").toLowerCase();
  if (!HOST.test(host)) return null;
  return host.replace(/^www\./, "");
};

// Turns what a seller typed into an https link we can open, or null.
// "www.shop.com" and "shop.com/page" get https:// added. Anything with
// another scheme (http:, javascript:, tel:...) or no domain (an @handle)
// returns null and should stay plain text. http:// is never upgraded to
// https:// silently: the https site could belong to someone else.
export const normalizeExternalUrl = (value) => {
  const raw = (value || "").trim();
  if (!raw || /\s/.test(raw)) return null;
  let candidate;
  if (/^https:\/\//i.test(raw)) candidate = raw;
  else if (SCHEME.test(raw)) return null;
  else if (BARE_DOMAIN.test(raw)) candidate = `https://${raw}`;
  else return null;
  return getUrlDomain(candidate) ? candidate : null;
};
